import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { StudyProvider } from '../contexts/StudyContext';
import { useApp } from '../contexts/AppContext';

// Import your components
import Login from '../components/auth/Login';
import Signup from '../components/auth/Signup';
import Layout from '../components/layouts/Layout';
import Dashboard from '../components/dashboard/Dashboard';
import AIAnalysis from '../components/pages/AIAnalysis';
import Profile from '../components/pages/Profile';
import WrongAnswerJournal from '../components/analytics/WrongAnswerJournal';
import Analytics from '../components/pages/Analytics';
import LandingPage from '../components/pages/LandingPage';
import LearningResources from '../components/pages/LearningResources';
import Community from '../components/pages/Community';
import QuestionDetail from '../components/analytics/QuestionDetail';

// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  return children;
};

// Public Route wrapper - redirects to app if user is authenticated
const PublicRoute = ({ children }) => {
  const { currentUser } = useAuth();
  
  if (currentUser) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

const AppRoutes = () => {
  const { currentUser } = useAuth();

  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/signup"
        element={
          <PublicRoute>
            <Signup />
          </PublicRoute>
        }
      />
      
      {/* Protected Routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={
          <StudyProvider>
            <Dashboard />
          </StudyProvider>
        } />
        <Route path="analyze" element={
          <StudyProvider>
            <AIAnalysis />
          </StudyProvider>
        } />
        <Route path="profile" element={<Profile />} />
        <Route path="journal">
          <Route index element={<WrongAnswerJournal />} />
          <Route path="question/:questionId" element={<QuestionDetail />} />
        </Route>
        <Route path="analytics" element={<Analytics />} />
        <Route path="resources" element={<LearningResources />} />
        <Route path="community" element={<Community />} />
      </Route>

      {/* Landing page */}
      <Route 
        path="/" 
        element={
          currentUser ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <PublicRoute>
              <LandingPage />
            </PublicRoute>
          )
        } 
      />
      
      {/* Catch all */}
      <Route 
        path="*" 
        element={
          currentUser ? (
            <Navigate to={currentUser ? "/dashboard" : "/"} replace />
          ) : (
            <Navigate to="/" replace />
          )
        } 
      />
    </Routes>
  );
};

export default AppRoutes; 